import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './responsive.css';
import App from './App';
import "flowbite";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import $ from "jquery";
import defaultAvatar from "./assets/profile.png";
import axios from "axios";
import { installOwnProfileInvalidation } from "./utils/auth";
window.$ = window.jQuery = $;
installOwnProfileInvalidation(axios);

// Each tab keeps its own sessionStorage copy of the token, so a logout (or a login as someone else)
// in another tab must end this tab's session as well
// A tab opened directly reads the token from localStorage only, so the token this tab was loaded with is kept too
const tokenAtLoad = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
window.addEventListener("storage", (e) => {
  if (e.storageArea !== localStorage) return;
  const tokenChanged = e.key === null || (e.key === "accessToken" && e.newValue !== e.oldValue);
  const tabToken = sessionStorage.getItem("accessToken") || tokenAtLoad;
  if (!tokenChanged || !tabToken) return;
  if (e.key === "accessToken" && e.newValue && e.newValue === tabToken) return;
  sessionStorage.clear();
  window.location.replace("/login");
});

window.addEventListener(
  "error",
  (e) => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.avatarFallback) return;
    const isAvatar =
      img.classList.contains("rounded-full") ||
      /profile|avatar|user|group|family|member/i.test(img.alt || "");
    if (!isAvatar) return;
    img.dataset.avatarFallback = "1";
    img.src = defaultAvatar;
  },
  true
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
